<template>
   <g>
      <path
         d="M7.88224 0.625H8.091C10.5839 0.625 11.8319 0.625 12.6975 1.1836C12.9453 1.3432 13.1655 1.5336 13.3513 1.7471C13.9998 2.4933 13.9998 3.5671 13.9998 5.7161V7.4976C13.9998 9.5717 13.9998 10.6091 13.6411 11.4372C13.0646 12.7693 11.8456 13.8193 10.2994 14.3163C9.33821 14.625 8.13535 14.625 5.72657 14.625C4.35165 14.625 3.66343 14.625 3.11438 14.4486C2.23116 14.1644 1.53452 13.5645 1.20494 12.8036C1 12.3304 1 11.7375 1 10.5524V7.625"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M14.0007 7.625C14.0007 8.24378 13.7322 8.83721 13.2542 9.27475C12.7762 9.71229 12.128 9.9581 11.452 9.9581C10.9427 9.9581 10.3424 9.8769 9.84766 9.998C9.63157 10.0512 9.43454 10.1554 9.27631 10.3003C9.11808 10.4451 9.0042 10.6255 8.94609 10.8233C8.8138 11.2762 8.9025 11.8257 8.9025 12.2919C8.9025 12.5983 8.83658 12.9017 8.70849 13.1847C8.58041 13.4678 8.39267 13.725 8.156 13.9417C7.91933 14.1583 7.63836 14.3302 7.32914 14.4474C7.01991 14.5647 6.68848 14.625 6.35378 14.625M1.76562 2.375C2.14185 2.0208 3.14207 0.625 3.67736 0.625M3.67736 0.625C4.21264 0.625 5.21286 2.0208 5.58909 2.375M3.67736 0.625V6.225"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-uploads',
         viewBox: '0 0 15 16',
         width: 15,
         height: 16,
         fill: 'none',
      };
   },
};
</script>
